import { render, staticRenderFns } from "./DkoFormCard.vue?vue&type=template&id=0b171525&scoped=true"
import script from "./DkoFormCard.vue?vue&type=script&lang=js"
export * from "./DkoFormCard.vue?vue&type=script&lang=js"
import style0 from "./DkoFormCard.vue?vue&type=style&index=0&id=0b171525&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b171525",
  null
  
)

export default component.exports